<template>
  <div class="dot" :class="{ 'is-deployed': isDeployed }"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    isDeployed: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.dot {
  display: inline-block;
  border-radius: 50%;
  border: 1px solid $grey-6;
  background-color: $red-5;

  background-color: transparent;
  width: 10px;
  height: 10px;

  &.is-deployed {
    border-color: $green-3;
    background-color: $green-5;
  }
}
</style>
